import React, { useState } from 'react';
import { FiSettings, FiLock, FiBriefcase } from 'react-icons/fi';
import { useAuth } from '../../context/AuthContext';
import ChangePassword from './ChangePassword';
import CompanySettings from './CompanySettings';

const Settings = () => {
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState('company');

  const tabs = [
    { id: 'company', label: 'Company Settings', icon: FiBriefcase },
    { id: 'password', label: 'Change Password', icon: FiLock }
  ];

  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-800">Settings</h1>
        <p className="text-gray-600 text-sm mt-1">Manage your company and account settings</p>
      </div>

      {/* Tabs */}
      <div className="mb-6">
        <div className="border-b border-gray-200">
          <nav className="-mb-px flex space-x-8">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center gap-2 py-4 px-1 border-b-2 font-medium text-sm transition-colors ${
                  activeTab === tab.id
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                <tab.icon size={18} />
                {tab.label}
              </button>
            ))}
          </nav>
        </div>
      </div>

      {/* Tab Content */}
      <div className="max-w-4xl">
        {activeTab === 'company' && <CompanySettings />}
        {activeTab === 'password' && <ChangePassword />}
      </div>
    </div>
  );
};

export default Settings;
